"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const moment = require("moment");
const filter_item_type_1 = require("../model/filter-item-type");
const text_filter_item_1 = require("../model/text-filter-item");
const boolean_filter_item_1 = require("../model/boolean-filter-item");
const number_filter_item_1 = require("../model/number-filter-item");
const category_day_filter_item_1 = require("../model/category-day-filter-item");
const date_filter_item_1 = require("../model/date-filter-item");
const money_filter_item_1 = require("../model/money-filter-item");
const category_filter_item_1 = require("../model/category-filter-item");
const week_filter_item_1 = require("../model/week-filter-item");
const year_filter_item_1 = require("../model/year-filter-item");
const quarter_filter_item_1 = require("../model/quarter-filter-item");
const semi_annual_filter_item_1 = require("../model/semi-annual-filter-item");
const month_filter_item_1 = require("../model/month-filter-item");
const page_date_filter_helper_1 = require("./page-date-filter-helper");
exports.categoryTypesMap = new Map([
    [idm_dataset_service_client_js_1.CategoryType.DATE, filter_item_type_1.FilterItemType.CATEGORY_DATE],
    [idm_dataset_service_client_js_1.CategoryType.CURRENCY, filter_item_type_1.FilterItemType.CATEGORY_CURRENCY],
    [idm_dataset_service_client_js_1.CategoryType.DOCUMENT, filter_item_type_1.FilterItemType.CATEGORY_DOCUMENT],
    [idm_dataset_service_client_js_1.CategoryType.INDICATOR, filter_item_type_1.FilterItemType.CATEGORY_STANDARD],
    [idm_dataset_service_client_js_1.CategoryType.STANDARD, filter_item_type_1.FilterItemType.CATEGORY_STANDARD],
    [idm_dataset_service_client_js_1.CategoryType.ME_ASSETS, filter_item_type_1.FilterItemType.CATEGORY_ME_ASSETS],
    [idm_dataset_service_client_js_1.CategoryType.DISAGGREGATION, filter_item_type_1.FilterItemType.CATEGORY_ME_ASSETS],
    [idm_dataset_service_client_js_1.CategoryType.FRAMEWORK, filter_item_type_1.FilterItemType.CATEGORY_ME_ASSETS]
]);
exports.dateCategoryTypesMap = new Map([
    [idm_dataset_service_client_js_1.DateCategoryType.YEAR, filter_item_type_1.FilterItemType.CATEGORY_YEAR],
    [idm_dataset_service_client_js_1.DateCategoryType.SEMI_ANNUAL, filter_item_type_1.FilterItemType.CATEGORY_SEMI_ANNUAL],
    [idm_dataset_service_client_js_1.DateCategoryType.QUARTER, filter_item_type_1.FilterItemType.CATEGORY_QUARTER],
    [idm_dataset_service_client_js_1.DateCategoryType.MONTH, filter_item_type_1.FilterItemType.CATEGORY_MONTH],
    [idm_dataset_service_client_js_1.DateCategoryType.WEEK, filter_item_type_1.FilterItemType.CATEGORY_WEEK],
    [idm_dataset_service_client_js_1.DateCategoryType.DAY, filter_item_type_1.FilterItemType.CATEGORY_DAY]
]);
exports.measureTypesMap = new Map([
    [idm_dataset_service_client_js_1.MeasurePathType.BOOLEAN, filter_item_type_1.FilterItemType.MEASURE_BOOLEAN],
    [idm_dataset_service_client_js_1.MeasurePathType.DATE, filter_item_type_1.FilterItemType.MEASURE_DATE],
    [idm_dataset_service_client_js_1.MeasurePathType.DATETIME, filter_item_type_1.FilterItemType.MEASURE_DATE],
    [idm_dataset_service_client_js_1.MeasurePathType.MONEY, filter_item_type_1.FilterItemType.MEASURE_MONEY],
    [idm_dataset_service_client_js_1.MeasurePathType.NUMBER, filter_item_type_1.FilterItemType.MEASURE_NUMBER],
    [idm_dataset_service_client_js_1.MeasurePathType.TEXT, filter_item_type_1.FilterItemType.MEASURE_TEXT],
]);
function convertToFilterItemType(path) {
    if (path.hasOwnProperty('measurePathType')) {
        return exports.measureTypesMap.get(path['measurePathType']);
    }
    else if (path.hasOwnProperty('categoryType')) {
        return path['dateCategoryType'] != null ?
            exports.dateCategoryTypesMap.get(path['dateCategoryType']) :
            exports.categoryTypesMap.get(path['categoryType']);
    }
}
exports.convertToFilterItemType = convertToFilterItemType;
function convertPageFilterItemToFilterItem(pageFilterItem, onValueChange, reset = false) {
    switch (pageFilterItem.filterItemType) {
        case filter_item_type_1.FilterItemType.MEASURE_TEXT:
            return new text_filter_item_1.TextFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange);
        case filter_item_type_1.FilterItemType.MEASURE_BOOLEAN:
            return new boolean_filter_item_1.BooleanFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange);
        case filter_item_type_1.FilterItemType.MEASURE_NUMBER:
            return new number_filter_item_1.NumberFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : null);
        case filter_item_type_1.FilterItemType.MEASURE_DATE:
            return new date_filter_item_1.DateFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : page_date_filter_helper_1.processMeasureDateFilterResetState(pageFilterItem.defaultValues));
        case filter_item_type_1.FilterItemType.MEASURE_MONEY:
            return new money_filter_item_1.MoneyFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, pageFilterItem.currencyId);
        case filter_item_type_1.FilterItemType.CATEGORY_DAY:
            return new category_day_filter_item_1.CategoryDayFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : processDateTypeResetState(pageFilterItem.defaultValues));
        case filter_item_type_1.FilterItemType.CATEGORY_WEEK:
            return new week_filter_item_1.WeekFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : processDateTypeResetState(pageFilterItem.defaultValues), pageFilterItem.isCacheable, pageFilterItem.searchCategoryFields);
        case filter_item_type_1.FilterItemType.CATEGORY_MONTH:
            return new month_filter_item_1.MonthFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : processDateTypeResetState(pageFilterItem.defaultValues), pageFilterItem.isCacheable, pageFilterItem.searchCategoryFields);
        case filter_item_type_1.FilterItemType.CATEGORY_YEAR:
            return new year_filter_item_1.YearFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : processDateTypeResetState(pageFilterItem.defaultValues), pageFilterItem.isCacheable, pageFilterItem.searchCategoryFields);
        case filter_item_type_1.FilterItemType.CATEGORY_QUARTER:
            return new quarter_filter_item_1.QuarterFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : processDateTypeResetState(pageFilterItem.defaultValues), pageFilterItem.isCacheable, pageFilterItem.searchCategoryFields);
        case filter_item_type_1.FilterItemType.CATEGORY_SEMI_ANNUAL:
            return new semi_annual_filter_item_1.SemiAnnualFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, !reset ? pageFilterItem.defaultValues : processDateTypeResetState(pageFilterItem.defaultValues), pageFilterItem.isCacheable, pageFilterItem.searchCategoryFields);
        case filter_item_type_1.FilterItemType.CATEGORY_STANDARD:
        case filter_item_type_1.FilterItemType.CATEGORY_ME_ASSETS: {
            return new category_filter_item_1.CategoryFilterItem(pageFilterItem.id, pageFilterItem.label, onValueChange, pageFilterItem.searchable, pageFilterItem.searchCategoryName, pageFilterItem.searchCategoryFields, !reset ? pageFilterItem.defaultValues : null, pageFilterItem.isCacheable, pageFilterItem.lookupSelectionType, pageFilterItem.mustBeConvertedToCategoryFilter);
        }
    }
}
exports.convertPageFilterItemToFilterItem = convertPageFilterItemToFilterItem;
function convertPageFilterItemsToFilterItems(pageFilterItem, onValueChange, reset = false) {
    return pageFilterItem.map(filterItem => convertPageFilterItemToFilterItem(filterItem, onValueChange, reset)).filter(filterItem => !!filterItem);
}
exports.convertPageFilterItemsToFilterItems = convertPageFilterItemsToFilterItems;
function addOrSubtractTime(inputDate, type, value) {
    const date = moment.utc(inputDate);
    let unit;
    switch (type) {
        case filter_item_type_1.FilterItemType.CATEGORY_YEAR:
            unit = "years";
            break;
        case filter_item_type_1.FilterItemType.CATEGORY_SEMI_ANNUAL:
            value *= 6;
            unit = "months";
            break;
        case filter_item_type_1.FilterItemType.CATEGORY_QUARTER:
            unit = "quarters";
            break;
        case filter_item_type_1.FilterItemType.CATEGORY_MONTH:
            unit = "months";
            break;
        case filter_item_type_1.FilterItemType.CATEGORY_WEEK:
            unit = "weeks";
            break;
        case filter_item_type_1.FilterItemType.CATEGORY_DAY:
            unit = "days";
            break;
        default:
            throw new Error("Invalid time period type `" + type + "'");
    }
    value > 0 ? date.add(value, unit) : date.subtract(Math.abs(value), unit);
    return date.toDate();
}
exports.addOrSubtractTime = addOrSubtractTime;
function dateToDateCategoryId(inputDate, type) {
    const date = moment.utc(inputDate);
    const year = date.year();
    const month = date.month() + 1;
    const quarter = Math.ceil(month / 3);
    const semiAnnual = Math.ceil(month / 6);
    const week = date.week();
    const day = date.dayOfYear();
    switch (type) {
        case filter_item_type_1.FilterItemType.CATEGORY_YEAR:
            return year;
        case filter_item_type_1.FilterItemType.CATEGORY_SEMI_ANNUAL:
            return year * 100 + semiAnnual;
        case filter_item_type_1.FilterItemType.CATEGORY_QUARTER:
            return year * 10 + quarter;
        case filter_item_type_1.FilterItemType.CATEGORY_MONTH:
            return year * 1000 + quarter * 100 + month;
        case filter_item_type_1.FilterItemType.CATEGORY_WEEK:
            return year * 100000 + quarter * 10000 + month * 100 + week;
        case filter_item_type_1.FilterItemType.CATEGORY_DAY:
            return year * 100000000 + quarter * 10000000 + month * 100000 + week * 1000 + day;
        default:
            throw new Error("Invalid time period type `" + type + "'");
    }
}
exports.dateToDateCategoryId = dateToDateCategoryId;
function processDateTypeResetState(state) {
    return Object.assign({}, state, { dateType: null, valueFrom: null, valueTo: null });
}
//# sourceMappingURL=page-filter-helper.js.map